import { render, staticRenderFns } from "./MultiSelectNew.vue?vue&type=template&id=6ca2b726&scoped=true&"
import script from "./MultiSelectNew.vue?vue&type=script&lang=js&"
export * from "./MultiSelectNew.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectNew.vue?vue&type=style&index=0&id=6ca2b726&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca2b726",
  null
  
)

export default component.exports